import { Entity } from '@core/api/entity';
import { DataroomNodeChoiceDTO } from '@core/dto/dataroom-node-choice.dto';
import { Model, Serializer } from '@junte/serialize-ts';

export class DataroomNodeChoiceSerializer implements Serializer<DataroomNodeChoice> {
  public deserialize(dto: DataroomNodeChoiceDTO): DataroomNodeChoice {
    return DataroomNodeChoice.create({
      ...dto,
      id: dto.uid,
    });
  }

  public serialize(model: DataroomNodeChoice): DataroomNodeChoiceDTO {
    return {
      ...model,
      uid: model.id,
    };
  }
}

@Model(new DataroomNodeChoiceSerializer())
export class DataroomNodeChoice extends Entity {
  public name: string;

  public static create(data: Partial<DataroomNodeChoice>): DataroomNodeChoice {
    return Object.assign(new DataroomNodeChoice(), data);
  }
}
